import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicFondsrelevanz } from '@bindoc-projects/virtual-clinic-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';

export const AT_FONDSRELEVANZ_CONDITION_ID = 'fondsrelevanzAT';
export const AtFilterConditionFondsrelevanzPluginType: FilterConditionPluginSpecification<
  AtVirtualClinicFondsrelevanz[],
  AtFilterConditionFondsrelevanzDto,
  FondsrelevanzATCondition
> = {
  type: 'fondsrelevanzAT',
  category: 'case',
  displayName: { de: 'Fondsrelevanz' },
  sortingIndex: 11,
  occurrence: 'multiple',
  fromObject(
    obj: AtFilterConditionFondsrelevanzDto,
  ): FilterConditionPluginImpl<AtVirtualClinicFondsrelevanz[]> {
    return new AtFilterConditionFondsrelevanzPlugin(obj.fondsrelevanz);
  },
  fromCondition(
    jsonObj: FondsrelevanzATCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicFondsrelevanz[]> {
    return new AtFilterConditionFondsrelevanzPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicFondsrelevanz[]> {
    return new AtFilterConditionFondsrelevanzPlugin([]);
  },
};

export class AtFilterConditionFondsrelevanzPlugin extends FilterConditionPluginImpl<
  AtVirtualClinicFondsrelevanz[],
  AtFilterConditionFondsrelevanzDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicFondsrelevanz[],
    AtFilterConditionFondsrelevanzDto,
    FondsrelevanzATCondition
  > = AtFilterConditionFondsrelevanzPluginType;

  constructor(protected fondsrelevanz: AtVirtualClinicFondsrelevanz[]) {
    super(AtFilterConditionFondsrelevanzPluginType.type);
  }

  toCondition(): BdCondition {
    return new FondsrelevanzATCondition(this.fondsrelevanz, []);
  }

  toJSON(): AtFilterConditionFondsrelevanzDto | null {
    return {
      type: this.type,
      fondsrelevanz: this.fondsrelevanz,
    };
  }

  toText(): string | null {
    return `Fondsrelevanz`;
  }

  toValue(): AtVirtualClinicFondsrelevanz[] {
    return this.fondsrelevanz;
  }

  override equals(other: AtFilterConditionFondsrelevanzPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.fondsrelevanz, other.fondsrelevanz)
    );
  }

  override validationToText(): string {
    if (this.fondsrelevanz.length === 0) {
      return 'Mindestens eine Fondsrelevanz auswählen';
    } else {
      return '';
    }
  }

  clone(): AtFilterConditionFondsrelevanzPlugin {
    return new AtFilterConditionFondsrelevanzPlugin(this.fondsrelevanz);
  }
}

export class FondsrelevanzATCondition extends BdContentCondition<AtVirtualClinicFondsrelevanz> {
  constructor(
    includes: AtVirtualClinicFondsrelevanz[],
    excludes: AtVirtualClinicFondsrelevanz[],
  ) {
    super(AT_FONDSRELEVANZ_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionFondsrelevanzDto {
  type: string;
  fondsrelevanz: AtVirtualClinicFondsrelevanz[];
}
